<template>
  <app-modal ref="modal" target="promo-code-warning-modal" close-on-backdrop-click>
    <div class="promo-code-modal">
      <p class="u-typography-helvetica u-text u-text--s">{{ $t(errorMessage) }}</p>
      <app-button v-modal-submit class="promo-code-modal__action-button">{{
        $t('promocode.button.continue')
      }}</app-button>
    </div>
  </app-modal>
</template>

<script>
import AppButton from '@/components/common/AppButton.vue';
import AppModal from '@/components/common/AppModal.vue';

import { PROMOCODE_APPLYING_ERROR } from '@/constants/notifications';

const MESSAGE = {
  [PROMOCODE_APPLYING_ERROR.DOES_NOT_WORK_IN_COUNTRY]: 'error.invalidPromocodeForCountry',
  [PROMOCODE_APPLYING_ERROR.DOES_NOT_EXIST]: 'error.invalidPromocode'
};

export default {
  name: 'PromoCodeWarningModal',
  components: { AppButton, AppModal },
  props: {
    error: {
      type: String,
      required: true
    }
  },
  computed: {
    errorMessage() {
      return MESSAGE[this.error];
    }
  },
  methods: {
    open() {
      return this.$refs.modal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors';

.promo-code-modal:lang(ar) {
  direction: rtl;
}

.promo-code-modal {
  background-color: $white-color;
  padding: 48px;
  width: 670px;
  max-width: 100%;
  color: var(--u-color-grey-900);

  &__action-button {
    width: 100%;
    height: 64px;
    margin-top: 29px;
    font-family: var(--u-font-family-Gilroy);
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: 0.75px;
  }

  &__action-button:lang(ar) {
    letter-spacing: normal;
  }
}
</style>
